module.exports = "mutation deleteWishlistProduct($wishlistProductId:ID!){deleteWishlistProduct(wishlistProductId:$wishlistProductId)}"